import { ref } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
import { define, allLanguages } from '@/data/globals.js'
import useNotify from '@/hooks/useNotify'
import notifys from '@/data/languages/notifications/useProductsData'
import useLang from '@/hooks/useLang'

export default function useProducts () {
    const store = useStore()
    const { pushNotify } = useNotify()
    const { lang } = useLang()
    const translateTo = ref()
    const limit = ref(12)



    async function getProducts() {
        if(!store.state.isAuth) return
        store.commit('SetIsProdsLoading', true)
        try {
            const response = await axios.get( define.pathToAPI + "/products/", 
                {
                    params: {
                        sort: store.state.sortSelected,
                        page: store.state.page,
                        limit: limit.value,
                        language: store.state.language,
                    },
                }
            ) // axios

            // console.log('response: ', response);
            // console.log('response.data.records: ', response.data.records);

            if(response.data){
                if(response.data.records.length > 0){
                    store.commit('SetProducts', response.data.records)

                    let totalPages = Math.ceil( response.data.totalCount / limit.value )
                    store.commit('SetTotalPages', totalPages)
                }
            } else {
                // Ошибка. Сервер вернул некорректный ответ
                pushNotify( notifys[lang.value].incorrectResp, 'notifyOrange')
            }

        } catch (e) {
            // console.log('e: ', e);

            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
                // console.log('Нет подключения к серверу')
                return
            }

            // Обработка ошибок
            switch(e.response.data.status) {
                case 'notfound':
                    store.commit('SetProducts', [])
                    // Нет данных
                    console.log('Нет данных')
                    break
                default:
                    pushNotify('Ошибка при получении данных от сервера', 'notifyOrange')
                    // console.log('Ошибка при получении данных от сервера')
                    console.log('e: ', e);
                    break
            } // switch

        } finally {
            store.commit('SetIsProdsLoading', false)
        }   

    } // getProducts





    async function getUpdProd(paramId, translate) {
        // console.log('paramId: ' + paramId)

        if(!store.state.isAuth) return
        if(!store.state.language) return

        store.commit('SetIsProdsLoading', true)
        store.commit('SetUpdProdFreeze', true)
        store.commit('ClearUpdProd')

        try {
            const response = await axios.get( define.pathToAPI + "/products/", 
                {
                    params: {
                        id: paramId,
                        language: store.state.language,
                    },
                }
            ) // axios

            // console.log('getUpdProd response: ', response)
            // console.log('getUpdProd status: ', response.data.status);

            if(response.data.records[0].id > 0){

                store.commit('SetUpdProd', [
                    response.data.records[0].id,
                    response.data.records[0].price,
                    response.data.records[0].pictures,
                    response.data.records[0].brand,
                    response.data.records[0].model
                ])

                if(translate) await getTranslations()

            } else {
                // Ошибка. Сервер вернул некорректный ответ
                pushNotify( notifys[lang.value].incorrectResp, 'notifyOrange')
                // console.log('Ошибка. Сервер вернул некорректный ответ');
            }

        } catch (e) {
            // console.log('e: ', e);
                
            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
                // console.log('Нет подключения к серверу')
                return
            }

            // Обработка ошибок
            switch(e.response.data.status) {
                case 'notfound':
                    // Нет данных
                    pushNotify( notifys[lang.value].noData, 'notifyOrange')
                    console.log('Нет данных')
                    break
                default:
                    // Ошибка при получении данных от сервера
                    pushNotify( notifys[lang.value].errRespData, 'notifyOrange')
                    // console.log('Ошибка при получении данных от сервера')
                    console.log('e: ', e);
                    break
            } // switch

        } finally {
            store.commit('SetIsProdsLoading', false)
            store.commit('SetUpdProdFreeze', false)
        }                
    } // getUpdProd




    async function getTranslations() {
        if(!store.state.isAuth) return
        if(!store.state.updProd.id) return

        // Определяем язык перевода
        switch(store.state.language) {
            case allLanguages[0]:
                translateTo.value = allLanguages[1]
                break
            case allLanguages[1]:
                translateTo.value = allLanguages[0]
                break
            default:
                translateTo.value = allLanguages[1]
                break
        }

        try {
            const response = await axios.get( define.pathToAPI + "/products/", 
                {
                    params: {
                        id: store.state.updProd.id,
                        language: translateTo.value,
                    },
                }
            ) // axios

            if(response.data.records[0].id > 0){
                store.commit('SetUpdProdTranslation', [
                    response.data.records[0].brand,
                    response.data.records[0].model
                ])
            } else {
                // Ошибка. Сервер вернул некорректный ответ
                pushNotify( notifys[lang.value].incorrectResp, 'notifyOrange')
            }

        } catch (e) {
                
            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
                // console.log('Нет подключения к серверу')
                return
            }

            // Обработка ошибок
            switch(e.response.data.status) {
                case 'notfound':
                    break
                default:
                    // pushNotify('Ошибка. Подробности в консоли', 'notifyOrange')
                    console.log('error: ', e);
                    break
            } // switch

        } // try
    } // getTranslations




    
    // Удаление товара (из массива)
    function deleteData(id) {
        // console.log('deleteData() id:' + id)
        // Удаление объекта (по id) из массива products
        const filteredArr = store.state.products.filter(value => value.id !== id);

        store.commit('SetProducts', filteredArr)
        // Удаление выполнено
        pushNotify( notifys[lang.value].deleted, "notifyOrange")
// ################################################################
// Проверить:
// Нужно, чтобы удалялись и те картинки которые загружены в updateform
// ################################################################
        // console.log('Deleted! (Вывести на экран всплывающее уведомление)')
    }




    function checkPrice(value) {
        // оставляем только цыфры и точку
        let filteredValue = value.replace(/[^.\d]+/g,"").replace( /^([^.]*\.)|\./g, '$1' )

        return filteredValue
    }



    

    return { limit, getProducts, getUpdProd, deleteData, checkPrice }
}